module.exports = __webpack_public_path__ + "media/images/spctop-f72bb002e2a7f912735d05f6a6a1312e.png";